/* eslint-disable camelcase */
import Environment from './Environment';
import serviceUtils from './serviceUtils';
import Logger from './Logger';

const dummyPinterist = {
  pintrk() {
    // For sites that won't have window.pintrk available (Bitsy, WTE, and PNM)
  },
};

const transactionComplete = (trackingData, cartInfo) => {
  try {
    if (Environment.getEnv === 'PRODUCTION') {
      const lineItems = [];
      if (cartInfo.subscription && cartInfo.subscription.plan) {
        const subscriptionToAddData = {
          product_name: `${cartInfo.subscription.plan.title} Subscription`, // eslint-disable-line camelcase
          product_variant: 'Unknown', // eslint-disable-line camelcase
          // eslint-disable-line camelcase
          product_price:
            cartInfo.subscription.plan.costWithCoupon ||
            cartInfo.subscription.plan.actualCost,
          product_quantity: 1, // eslint-disable-line camelcase
          product_id: cartInfo.subscription.plan._id || '1234', // eslint-disable-line camelcase
        };
        lineItems.push(subscriptionToAddData);
      }
      if (cartInfo.productsAndDetails && cartInfo.productsAndDetails.length) {
        cartInfo.productsAndDetails.forEach((productAndDetails) => {
          let variant = 'NONE';
          if (
            productAndDetails.color !== 'NONE' &&
            productAndDetails.variation !== 'NONE'
          ) {
            variant = `${productAndDetails.color}, ${productAndDetails.variation}`;
          } else if (productAndDetails.color !== 'NONE') {
            variant = productAndDetails.color;
          } else if (productAndDetails.variation !== 'NONE') {
            variant = productAndDetails.variation;
          }
          const productToAddData = {
            // eslint-disable-line camelcase
            product_name:
              productAndDetails.product.name || 'Missing product name',
            product_variant: variant, // eslint-disable-line camelcase
            // eslint-disable-line camelcase
            product_price:
              productAndDetails.promoItem &&
              productAndDetails.product.ownPromoData
                ? productAndDetails.product.ownPromoData.cost
                : productAndDetails.product.actualCost || 0,
            product_quantity: productAndDetails.quantity || 1, // eslint-disable-line camelcase
            product_id: productAndDetails.product.sku || 'Missing product SKU', // eslint-disable-line camelcase
          };
          lineItems.push(productToAddData);
        });
      }
      let itemTotal = 0;
      if (cartInfo.subscription && cartInfo.subscription.plan) {
        itemTotal += 1;
      }
      if (cartInfo.productsAndDetails && cartInfo.productsAndDetails.length) {
        itemTotal += cartInfo.productsAndDetails.length;
      }
      let coupon = 'No coupon used';
      if (cartInfo.coupon && cartInfo.coupon.code) {
        coupon = cartInfo.coupon.code;
      }
      const pintrk = window.pintrk || dummyPinterist.pintrk;
      pintrk('track', 'checkout', {
        value: parseFloat(trackingData.total, 10),
        order_quantity: itemTotal, // eslint-disable-line camelcase
        currency: 'USD',
        order_id: trackingData.res.justPurchasedPurchaseId, // eslint-disable-line camelcase
        promo_code: coupon, // eslint-disable-line camelcase
        line_items: lineItems, // eslint-disable-line camelcase
      });
    }
  } catch (e) {
    Logger.error(e);
  }
};

const pageLoaded = () => {
  const pintrk = window.pintrk || dummyPinterist.pintrk;
  pintrk('track', 'PageVisit');
};

const updatedCart = (cart) => {
  try {
    const pintrk = window.pintrk || dummyPinterist.pintrk;

    const items = serviceUtils.getDataForCart(cart);
    if (items && items.length) {
      const cartData = {
        value: cart.subCosts ? cart.subCosts.overallTotal : 0,
        line_items: items, // eslint-disable-line camelcase
        order_quantity: items.length, // eslint-disable-line camelcase
        Provider: Environment.store,
      };
      pintrk('track', 'AddToCart', cartData);
    }
    return pintrk;
  } catch (e) {
    Logger.error(e);
  }
  return cart;
};

export default {
  transactionComplete,
  pageLoaded,
  updatedCart,
};
